module.exports = __webpack_public_path__ + "img/1 (81).86d95f98.png";